import { CSSObject } from '@chakra-ui/react';

export const NoResultsText: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'bold',
};

export const FlexBetCard: CSSObject = {};
